// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  border-radius: 10px;
  background: var(--ion-item-background);
  margin: 16px 0;
}
ion-grid ion-row {
  border-bottom: 1px solid var(--ion-item-border-color);
  margin: 0px 16px;
}
ion-grid ion-row ion-col:nth-child(2), ion-grid ion-row :nth-child(4), ion-grid ion-row :nth-child(6) {
  text-align: right;
}
ion-grid ion-row:last-child {
  border-bottom: 0;
}
ion-grid h6 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #747889;
}
ion-grid h3 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-top: 0;
}
ion-grid .in-active {
  color: #FF8686;
}
ion-grid .active {
  color: #63EDBB;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/payments/view/view.page.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,sCAAA;EACA,cAAA;AACJ;AAAI;EACI,qDAAA;EACA,gBAAA;AAER;AAAQ;EACI,iBAAA;AAEZ;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAII;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAFR;AAKI;EACI,cAAA;AAHR;AAKI;EACI,cAAA;AAHR","sourcesContent":["ion-grid {\n    border-radius: 10px;\n    background: var(--ion-item-background);\n    margin: 16px 0;\n    ion-row {\n        border-bottom: 1px solid var(--ion-item-border-color);\n        margin: 0px 16px;\n        \n        ion-col:nth-child(2),:nth-child(4),:nth-child(6) {\n            text-align: right;\n        }\n    }\n\n    ion-row:last-child {\n        border-bottom: 0;\n    }\n\n    h6 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 16px;\n        color: #747889;\n    }\n    \n    h3 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n        margin-top: 0;\n    }\n\n    .in-active {\n        color: #FF8686;\n    }\n    .active {\n        color: #63EDBB;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
